import {
    ArrayPath,
    ControllerFieldState,
    FieldArrayWithId
} from "react-hook-form";

import { FormFeedback } from "@/components/Form/Base/formFeedback.component";
import { FormText } from "@/components/Form/Base/formText.component";
import { Input } from "@/components/Form/Base/input.component";
import { Label } from "@/components/Form/Base/label.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { TermsOfServiceFieldValues } from "../termsOfServiceCheck.schema";

type TermsOfServiceDocumentFieldItemProps = {
    name: string;
    onChange: (...event: any[]) => void;
    document: FieldArrayWithId<
        TermsOfServiceFieldValues,
        Extract<ArrayPath<TermsOfServiceFieldValues>, "termsOfServiceChecks">,
        "id"
    >;
    fieldState: ControllerFieldState;
};

const TermsOfServiceDocumentFieldItem = ({
    name,
    onChange,
    document,
    fieldState
}: TermsOfServiceDocumentFieldItemProps) => {
    const { t } = useGranite();
    const { file } = document;

    return (
        <>
            <p className={"mb-1"}>{document.title}</p>
            <section className={"d-flex align-items-start"}>
                <Input
                    name={name}
                    type={"checkbox"}
                    onChange={onChange}
                    id={name}
                    checked={document.checked}
                    valid={fieldState.isTouched && !fieldState.error}
                    invalid={fieldState.isTouched && !!fieldState.error}
                />
                <div className={"pl-2"}>
                    <Label
                        htmlFor={name}
                        className={"m-0"}
                    >
                        {t(
                            "checkout.customerDetails.additionalServiceTermsOfService.label"
                        )}{" "}
                        <a
                            href={file.url}
                            title={file.altText ?? ""}
                            target={"_blank"}
                            rel="noopener"
                        >
                            {t(
                                "checkout.customerDetails.additionalServiceTermsOfService.label.termsOfService"
                            )}
                        </a>
                    </Label>
                    <FormText>
                        {t(
                            "checkout.customerDetails.additionalServiceTermsOfService.microcopy"
                        )}
                    </FormText>
                    {fieldState.error && (
                        <FormFeedback>
                            {fieldState.error.message()(t)}
                        </FormFeedback>
                    )}
                </div>
            </section>
        </>
    );
};

export { TermsOfServiceDocumentFieldItem };
